export default "__VITE_ASSET__DhuJz_de__"